import { createStore } from 'vuex'

export const dataHome = createStore({
  state: () => {
    return {
      lastRecords: [],
      cards: [],
      collab: {
        name: null,
        cards: []
      },
      allCollabs: [],

      form: {
        user_id: undefined,
        period: undefined,
        pontoType: undefined,
        date_start: null,
        date_end: null
      }
    }
  },
  getters: {
    getLatestRecords: state => state.lastRecords,
    getCards: state => state.collab.cards,
    getCollab: state => state.collab,
    getAllCollabs: state => state.allCollabs,
  },
  mutations: {
    SET_RECORDS(state, payload) {
      state.lastRecords = payload
    },
    SET_CARDS_VALUE(state, payload) {
      state.collab.cards = payload
    },
    SET_DATA_COLLAB(state, payload) {
      state.collab = payload
    },
    SET_ALL_COLLAB_LIST(state, payload) {
      state.allCollabs = payload
    },
    
    ALTER_DATA_COLLAB(state, payload) {
      state.collab.hTrab = payload?.hTrab ?? state.collab.hTrab
      state.collab.hDeve = payload?.hDeve ?? state.collab.hDeve
      state.collab.hExtras = payload?.hExtras ?? state.collab.hExtras
      state.collab.faltas = payload?.faltas ?? state.collab.faltas
    },
  },
  actions: {
    setRecordsList({ commit }, value) {
      commit('SET_RECORDS', value);
    },
    setCards({ commit }, value) {
      commit('SET_CARDS_VALUE', value);
    },
    setDataCollab({ commit }, value) {
      commit('SET_DATA_COLLAB', value);
    },
    setAllCollabs({ commit }, value) {
      commit('SET_ALL_COLLAB_LIST', value);
    },
    updateStatisticsByCollab({ commit }, value) {
      commit('ALTER_DATA_COLLAB', value);
    },
    

  }
})
